module.exports = __webpack_public_path__ + "youtube.5d945ca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/youtube.png
// module id = 1520
// module chunks = 0